import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/metaPixel';

const INTERNAL_ROUTE_PREFIXES = ['/admin', '/dashboard', '/orders'];

const MetaPixelTracker = () => {
  const location = useLocation();
  const lastTrackedPage = useRef('');

  useEffect(() => {
    const isInternalRoute = INTERNAL_ROUTE_PREFIXES.some((prefix) => (
      location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
    ));

    if (isInternalRoute) return;

    const pageKey = `${location.pathname}${location.search}`;
    if (lastTrackedPage.current === pageKey) return;

    lastTrackedPage.current = pageKey;
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;
